import React from 'react';

import {AaSequenceAlignmentPanelState} from 'FileStates';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import AaSequenceAlignmentPanel from 'toolbar/aa-sequence/AaSequenceAlignmentPanel';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';

class ProteinAlignmentPanelView extends ReactPanelBaseView<AaSequenceAlignmentPanelState, AaSequence> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('proteinAlignment'),
        title: 'Alignments',
        // eslint-disable-next-line @typescript-eslint/unbound-method
        component: <AaSequenceAlignmentPanel proteinId={this.model.id} closePanel={this.closePanel} />,
      },
    ];
  }
}

export default ProteinAlignmentPanelView;
